export default "__VITE_ASSET__M7vYNA$n__"